// Actions
import {
  SET_USA,
  SET_INTERNATIONAL,
  SET_GEOGRAPHY_STATE
} from "../actionTypes/geography.actionTypes";

// Classes
import {
  USA,
  International,
  GeographyReducerState
} from "../classes/geography.classes";

export interface ISetUSAAction {
  type: string;
  payload: USA;
}

export function setUSA(usa: USA): ISetUSAAction {
  return { type: SET_USA, payload: usa };
}

export interface ISetInternationalAction {
  type: string;
  payload: International;
}

export function setInternational(
  international: International
): ISetInternationalAction {
  return { type: SET_INTERNATIONAL, payload: international };
}

export interface ISetGeographyStateAction {
  type: string;
  payload: GeographyReducerState;
}

export function setGeographyState(
  state: GeographyReducerState
): ISetGeographyStateAction {
  return { type: SET_GEOGRAPHY_STATE, payload: state };
}
try {
    // @ts-ignore
    setUSA.displayName = "setUSA";
    // @ts-ignore
    setUSA.__docgenInfo = { "description": "", "displayName": "setUSA", "props": { "selection": { "defaultValue": null, "description": "", "name": "selection", "required": false, "type": { "name": "\"Any\" | \"None\" | \"US Regions\" | \"In-State\" | \"Out-of-State\" | \"Specific States/Territories\"" } }, "value": { "defaultValue": null, "description": "", "name": "value", "required": false, "type": { "name": "any[]" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/Demographics/Geography/actionCreators/geography.actionCreators.ts#setUSA"] = { docgenInfo: setUSA.__docgenInfo, name: "setUSA", path: "src/shared/containers/Filter/Demographics/Geography/actionCreators/geography.actionCreators.ts#setUSA" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setInternational.displayName = "setInternational";
    // @ts-ignore
    setInternational.__docgenInfo = { "description": "", "displayName": "setInternational", "props": { "selection": { "defaultValue": null, "description": "", "name": "selection", "required": false, "type": { "name": "\"Any\" | \"None\" | \"Specific Countries\"" } }, "value": { "defaultValue": null, "description": "", "name": "value", "required": false, "type": { "name": "any[]" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/Demographics/Geography/actionCreators/geography.actionCreators.ts#setInternational"] = { docgenInfo: setInternational.__docgenInfo, name: "setInternational", path: "src/shared/containers/Filter/Demographics/Geography/actionCreators/geography.actionCreators.ts#setInternational" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setGeographyState.displayName = "setGeographyState";
    // @ts-ignore
    setGeographyState.__docgenInfo = { "description": "", "displayName": "setGeographyState", "props": { "usa": { "defaultValue": null, "description": "", "name": "usa", "required": true, "type": { "name": "USA" } }, "international": { "defaultValue": null, "description": "", "name": "international", "required": true, "type": { "name": "International" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Filter/Demographics/Geography/actionCreators/geography.actionCreators.ts#setGeographyState"] = { docgenInfo: setGeographyState.__docgenInfo, name: "setGeographyState", path: "src/shared/containers/Filter/Demographics/Geography/actionCreators/geography.actionCreators.ts#setGeographyState" };
}
catch (__react_docgen_typescript_loader_error) { }